import { TableHeadContent } from './TableHeadContent';

export default TableHeadContent;
